import { DataGrid, gridClasses, GridColDef } from '@mui/x-data-grid';
import { dateFormatter } from '../../../../../../utils/timeFormat';
import { isDefaultDate } from '../../../../../../utils/common';
import { RootState } from '../../../../../../reducers';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../store/store';
import { isValid } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';
import { clearSelections, getMCAlerts, getMemberByAHCCCS, setRowSelectionModel, setSelectedAlert, setUnmatchedId } from '../../../../../../store/hie.slice';
import { useEffect, useState } from 'react';
import { toDate } from '../../../../../../utils/dateHelpers';
import { GridRowSelectionModel } from '@mui/x-data-grid';

const MedicaidCensus = () => {
    const dispatch = useAppDispatch();

    const { mcAlerts, showArchivedAlerts, unmatchedId } = useSelector((state: RootState) => state.hie);
    const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 10 });
    const [alertsRowSelectionModel, setAlertsRowSelectionModel] = useState<GridRowSelectionModel>({
        type: 'include', // or 'exclude'
        ids: new Set([]), // Your initial row IDs
    });

    const columns: GridColDef[] = [
        {
            field: 'LastName',
            headerName: 'Last Name',
            minWidth: 160,
        },
        {
            field: 'FirstName',
            headerName: 'First Name',
            minWidth: 160,
        },
        {
            field: 'DOB',
            headerName: 'DOB',
            flex: 1,
            valueGetter: (value, row) => `${isDefaultDate(row.DOB) ? '-' : dateFormatter(new Date(row.DOB))}`,
        },
        {
            field: 'CHPDownloadDate',
            headerName: 'Download Date',
            flex: 1,
            valueGetter: (value, row) => `${isDefaultDate(row.CHPDownloadDate) ? '-' : dateFormatter(new Date(row.CHPDownloadDate))}`,
        },
        {
            field: 'MemberAHCCCS',
            headerName: 'AHCCCS ID',
            flex: 1,
        },
        {
            field: 'SendingFacility',
            headerName: 'Sending Facility',
            flex: 1.5,
        },
        {
            field: 'VisitType',
            headerName: 'Visit Type',
            flex: 1,
        },
        {
            field: 'AdmitDate',
            headerName: 'Admission Date',
            minWidth: 160,
            flex: 1,
            valueGetter: (value, row) => {
                const d = toDate(row.AdmitDate);
                return `${!isValid(d) ? 'N/A' : formatInTimeZone(d, 'UTC', 'MM/dd/yyyy')}`;
            },
        },
    ];

    useEffect(() => {
        dispatch(getMCAlerts());
    }, [dispatch]);

    return (
        <>
            <DataGrid
                onRowClick={(params: any) => {
                    const { Id, MemberAHCCCS } = params.row;
                    dispatch(clearSelections());
                    dispatch(setUnmatchedId(Id));
                    dispatch(setSelectedAlert(params.row));
                    dispatch(getMemberByAHCCCS(MemberAHCCCS));
                }}
                autoHeight
                rows={showArchivedAlerts ? mcAlerts : mcAlerts.filter((alert) => alert.Archived !== true)}
                columns={columns}
                disableRowSelectionExcludeModel
                onRowSelectionModelChange={(newSelectionModel) => {
                    setAlertsRowSelectionModel(newSelectionModel);
                    const rowIds = Array.from(newSelectionModel.ids) || [];
                    dispatch(setRowSelectionModel(rowIds));
                }}
                rowSelectionModel={alertsRowSelectionModel}
                checkboxSelection={unmatchedId.length > 0 ? true : false}
                paginationModel={paginationModel}
                onPaginationModelChange={setPaginationModel}
                getRowHeight={() => 'auto'}
                pageSizeOptions={[5]}
                getRowId={(row) => row.Id}
                getRowClassName={(params) => (params.row.Archived ? 'archived' : '')}
                sx={{
                    [`& .${gridClasses.cell}`]: {
                        py: 1,
                    },
                    [`& .archived`]: {
                        background: 'rgba(200,200,200,0.4)',
                        fontStyle: 'italic',
                    },
                }}
            />
        </>
    );
};

export default MedicaidCensus;
